import { UnlabelledLineChart } from 'components/core-v2'

interface Props {
  data: [number, number][]
  isPositive: boolean
}
export const Last30DaysChart = ({ data, isPositive }: Props) => (
  <UnlabelledLineChart data={data} height={50} isPositive={isPositive} width={200} />
)
